import { Link } from "react-router-dom";
import usePageMeta from "@/hooks/usePageMeta";
import Breadcrumb from "@/components/feature/Breadcrumb";
import { categories } from "@/mocks/categories";

const principles = [
  {
    icon: "ri-focus-3-line",
    title: "我们追什么",
    text: "影视、音乐、综艺的一线动态，明星的公开行程与情感信息，以及与娱乐产业相关的社会议题。",
  },
  {
    icon: "ri-shield-check-line",
    title: "我们怎么核实",
    text: "优先采用当事人回应、公开画面与多方信源。只有单方描述的信息，会在文中明确标注「待核实」。",
  },
  {
    icon: "ri-time-line",
    title: "我们何时更新",
    text: "每日 08:00、14:00、21:00 三次集中更新，重大事件随时加更，专题内容随事件进展持续补充。",
  },
];

const notices = [
  "本网站为演示站点，站内全部文章、人物姓名、事件经过与数据均为虚构示例，不对应任何真实个人或机构。",
  "站内图片由编辑生成，仅用于示意版式与阅读效果，与文中描述的人物、场景无关。",
  "站内搜索为前端演示功能，基于示例数据做关键词匹配，不接入任何真实检索接口，也不会记录你的输入内容。",
  "分享按钮仅弹出本地提示，不会调用任何第三方分享接口，也不会上传链接或个人信息。",
  "欢迎转载站内内容用于学习与交流，请注明来源「黑料吃瓜网」并保留原文链接，不得用于商业用途。",
];

export default function AboutPage() {
  usePageMeta({
    title: "关于我们 - 黑料吃瓜网娱乐八卦资讯",
    description:
      "了解黑料吃瓜网的定位、内容范围、编辑原则与联系方式。我们关注娱乐八卦与热点事件，也坚持标注信源、理性围观。",
    keywords: "黑料吃瓜网,关于我们,娱乐八卦,编辑原则,联系方式",
  });

  return (
    <>
      <section className="w-full bg-primary-950">
        <div className="w-full max-w-[1280px] mx-auto px-4 md:px-6 py-10 md:py-16">
          <p className="text-[11px] tracking-[0.24em] text-accent-300 uppercase">About Hei Liao News</p>
          <h1 className="mt-3 font-heading text-3xl md:text-[46px] font-bold leading-tight text-background-50">
            关于黑料吃瓜网
          </h1>
          <p className="mt-4 max-w-2xl text-sm md:text-base leading-relaxed text-background-300">
            一个专注娱乐八卦与热点资讯的编辑团队。我们把「快」和「准」放在一起考虑，也相信围观需要边界。
          </p>
          <div className="mt-7 flex flex-wrap gap-3">
            <Link
              to="/category/entertainment"
              className="inline-flex items-center gap-1.5 px-5 py-2.5 rounded-md bg-accent-500 text-foreground-950 text-sm whitespace-nowrap hover:bg-accent-400 transition-colors cursor-pointer"
            >
              浏览资讯
              <i className="ri-arrow-right-line" />
            </Link>
            <a
              href="mailto:hi@heiliaogua.com"
              className="inline-flex items-center gap-1.5 px-5 py-2.5 rounded-md border border-background-700 text-background-200 text-sm whitespace-nowrap hover:border-background-500 transition-colors cursor-pointer"
            >
              <i className="ri-mail-line" />
              联系我们
            </a>
          </div>
        </div>
      </section>

      <div className="w-full max-w-[1280px] mx-auto px-4 md:px-6 py-7 md:py-10">
        <Breadcrumb items={[{ label: "关于我们" }]} />

        <section className="mt-7 grid grid-cols-1 lg:grid-cols-[minmax(0,1fr)_360px] gap-8 lg:gap-12 items-start">
          <div>
            <h2 className="font-heading text-xl md:text-[26px] font-bold text-foreground-950 flex items-center gap-2.5">
              <span className="w-1.5 h-5 md:h-6 rounded-full bg-primary-500 inline-block" />
              网站定位与内容范围
            </h2>
            <div className="mt-4 space-y-4 text-sm md:text-[15px] leading-relaxed text-foreground-700">
              <p>
                黑料吃瓜网面向喜欢追踪娱乐动态、明星绯闻与热点事件的网民，提供每日更新的娱乐资讯。
                我们不生产耸动的标题，也不为未经证实的说法提供传播渠道；对每一条信息，尽量交代它是从哪里来的。
              </p>
              <p>
                目前站点分为三个主要栏目：
                {categories.map((category, index) => (
                  <span key={category.id}>
                    {index > 0 ? "、" : ""}
                    <Link
                      to={`/category/${category.id}`}
                      className="text-primary-600 hover:text-primary-700 transition-colors"
                    >
                      {category.name}
                    </Link>
                  </span>
                ))}
                ，并围绕影视、情感、版权、演出经济等主题做了若干个内容专题。分类页支持按标签筛选与按时间、热度排序，
                搜索结果页支持按相关度和时间重新排序。
              </p>
              <p>
                需要特别说明的是：本网站为演示站点，所有内容均为虚构示例。我们保留这样一个站点，
                是为了展示一个娱乐资讯门户应该具备的信息结构——清晰的分类、可追溯的来源、以及克制的表达。
              </p>
            </div>

            <div className="mt-8 grid grid-cols-1 sm:grid-cols-3 gap-4">
              {principles.map((item) => (
                <div key={item.title} className="bg-background-50 border border-background-200 rounded-lg p-4">
                  <span className="w-9 h-9 rounded-md bg-primary-50 text-primary-600 flex items-center justify-center">
                    <i className={`${item.icon} text-lg`} />
                  </span>
                  <h3 className="mt-3 font-heading text-sm font-bold text-foreground-950">{item.title}</h3>
                  <p className="mt-1.5 text-xs leading-relaxed text-foreground-600">{item.text}</p>
                </div>
              ))}
            </div>

            <h2 className="mt-10 font-heading text-xl md:text-[26px] font-bold text-foreground-950 flex items-center gap-2.5">
              <span className="w-1.5 h-5 md:h-6 rounded-full bg-primary-500 inline-block" />
              使用须知
            </h2>
            <ul className="mt-4 space-y-3">
              {notices.map((notice, index) => (
                <li key={notice} className="flex items-start gap-3 text-sm leading-relaxed text-foreground-700">
                  <span className="shrink-0 w-5 h-5 rounded-full bg-background-200 text-foreground-600 flex items-center justify-center text-[11px] mt-0.5">
                    {index + 1}
                  </span>
                  {notice}
                </li>
              ))}
            </ul>

            <h2 className="mt-10 font-heading text-xl md:text-[26px] font-bold text-foreground-950 flex items-center gap-2.5">
              <span className="w-1.5 h-5 md:h-6 rounded-full bg-primary-500 inline-block" />
              版权声明
            </h2>
            <div className="mt-4 bg-background-200/60 border border-background-300/60 rounded-lg p-4 md:p-5 text-sm leading-relaxed text-foreground-700">
              <p>
                本站原创的版式、栏目结构与文字内容（不含演示性质的虚构文章）版权归黑料吃瓜网所有。
                转载、摘编或以其他方式使用，请事先取得书面许可，并注明来源与原文链接。
              </p>
              <p className="mt-2.5">
                若你认为站内内容侵犯了你的合法权益，请通过下方邮箱联系我们，注明具体页面链接与权利证明，
                我们将在收到通知后尽快核实处理。
              </p>
            </div>
          </div>

          <aside className="space-y-5 lg:sticky lg:top-[104px]">
            <div className="bg-background-50 border border-background-200 rounded-lg p-4 md:p-5">
              <h2 className="font-heading text-base font-bold text-foreground-950 flex items-center gap-2">
                <i className="ri-contacts-line text-primary-500" />
                联系方式
              </h2>
              <ul className="mt-3.5 space-y-3.5 text-sm">
                <li className="flex items-start gap-3">
                  <span className="w-8 h-8 shrink-0 rounded-md bg-background-100 text-foreground-600 flex items-center justify-center">
                    <i className="ri-mail-line" />
                  </span>
                  <span>
                    <span className="block text-xs text-foreground-500">内容合作与纠错</span>
                    <a
                      href="mailto:hi@heiliaogua.com"
                      className="block mt-0.5 text-foreground-900 hover:text-primary-600 transition-colors break-all"
                    >
                      hi@heiliaogua.com
                    </a>
                  </span>
                </li>
                <li className="flex items-start gap-3">
                  <span className="w-8 h-8 shrink-0 rounded-md bg-background-100 text-foreground-600 flex items-center justify-center">
                    <i className="ri-weibo-line" />
                  </span>
                  <span>
                    <span className="block text-xs text-foreground-500">官方微博</span>
                    <a
                      href="https://weibo.com"
                      target="_blank"
                      rel="nofollow noopener noreferrer"
                      className="block mt-0.5 text-foreground-900 hover:text-primary-600 transition-colors"
                    >
                      @黑料吃瓜网
                    </a>
                  </span>
                </li>
                <li className="flex items-start gap-3">
                  <span className="w-8 h-8 shrink-0 rounded-md bg-background-100 text-foreground-600 flex items-center justify-center">
                    <i className="ri-time-line" />
                  </span>
                  <span>
                    <span className="block text-xs text-foreground-500">工作时间</span>
                    <span className="block mt-0.5 text-foreground-900">周一至周五 10:00 – 19:00</span>
                  </span>
                </li>
              </ul>
              <p className="mt-4 text-[11px] leading-relaxed text-foreground-500">
                邮件通常在两个工作日内回复。涉及侵权投诉，请在标题注明「版权投诉」。
              </p>
            </div>

            <div className="bg-background-50 border border-background-200 rounded-lg p-4 md:p-5">
              <h2 className="font-heading text-base font-bold text-foreground-950 flex items-center gap-2">
                <i className="ri-team-line text-primary-500" />
                编辑团队
              </h2>
              <ul className="mt-3 space-y-2.5 text-xs text-foreground-700">
                {[
                  { name: "顾南乔", role: "娱乐组主编" },
                  { name: "陶然", role: "八卦组编辑" },
                  { name: "程也", role: "产业观察" },
                  { name: "闻笛", role: "调查报道" },
                  { name: "苏未晚", role: "音乐与人物" },
                ].map((member) => (
                  <li key={member.name} className="flex items-center justify-between gap-3">
                    <span className="flex items-center gap-2">
                      <span className="w-6 h-6 rounded-full bg-primary-50 text-primary-600 flex items-center justify-center text-[10px]">
                        {member.name.slice(0, 1)}
                      </span>
                      {member.name}
                    </span>
                    <span className="text-foreground-500">{member.role}</span>
                  </li>
                ))}
              </ul>
            </div>

            <div className="bg-primary-950 rounded-lg p-4 md:p-5">
              <p className="text-[11px] tracking-[0.2em] text-accent-300 uppercase">Responsible Reading</p>
              <p className="mt-2 text-sm leading-relaxed text-background-200">
                吃瓜是一种娱乐，但不该成为伤害别人的方式。请勿传播未经核实的信息，也不要对当事人进行人身攻击。
              </p>
              <Link
                to="/topic/topic-copyright-rules"
                className="mt-4 inline-flex items-center gap-1.5 text-xs text-accent-300 hover:text-accent-200 transition-colors cursor-pointer"
              >
                阅读「版权与规则」专题
                <i className="ri-arrow-right-line" />
              </Link>
            </div>
          </aside>
        </section>
      </div>
    </>
  );
}